export const DEFAULT_TRANSMITTER_DETECTION_RANGE = 2.5;
